import React from "react";

import Form from "./profile";

import { connect } from "react-redux";

import { CACHE_TAG, loadCache, isCacheLoading, isCacheLoaded } from "../../../../redux/actions/cache/interface";

import { getTagsForSelect, getTagsById } from "../../../../redux/actions/cache/tag";

import {
    load,
    isLoading,
    isLoaded,
    getData,
    isSecondaryLoading,
    updateTags,
} from "../../../../redux/actions/manager/vendor/tag";

import Loader from "../../../loader";

class Container extends React.Component {
    constructor(props) {
        super(props);

        this.state = { id: props.id };
    }

    componentDidMount() {
        this.props.loadCache();
        this.props.load(this.state.id);
    }

    render() {
        const { loading, loaded, alta } = this.props;

        return (
            <>
                <Loader loading={loading} />
                {!loading && loaded && <Form {...this.props} />}
            </>
        );
    }
}

const cacheList = [CACHE_TAG];

function MapStateToProps(state) {
    return {
        loading: isCacheLoading(state, cacheList) || isLoading(state),
        loaded: isCacheLoaded(state, cacheList) && isLoaded(state),
        data: getData(state),
        tags: getTagsForSelect(state),
        tagsById: getTagsById(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCache: () => loadCache(cacheList)(dispatch),
        load: (id) => dispatch(load(id)),
        updateTags: (id, form) => dispatch(updateTags(id, form)),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
